@if (imageUrl) {
  <img src="{{imageUrl}}" alt="Image" class="img-fluid" />
}
